import flattenObject from "@/utils/flattenObject";

export default function fuzzySearch<i extends any[]>(items: i, query: string) {
  const queryParts = query.toLowerCase().split(" ");
  let results = items.slice(0).map(item => {
    let stringifiedItem = JSON.stringify(item).toLowerCase();
    if (item instanceof Object) {
      stringifiedItem = JSON.stringify(Object.values(flattenObject(item))).toLowerCase();
    }
    return {
      item,
      stringifiedItem
    };
  });
  queryParts.forEach(queryPart => {
    results = results.filter(item => {
      return item.stringifiedItem.indexOf(queryPart) > -1;
    });
  });
  return results.map(result => result.item) as i;
}

export function fuzzyMatch(str: any, query = "") {
  const queryParts = query.toLowerCase().split(" ");
  return queryParts.every(queryPart => {
    return (
      JSON.stringify(str)
        .toLowerCase()
        .indexOf(queryPart) > -1
    );
  });
}
